<script lang="ts">
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import Time from 'svelte-time'
    import {getAllTransactionWithFilter} from 'src/components/cabinet/#services/getAllTransactionWithFilter'
    import {roundNumberFloor} from 'src/global/roundNumber'

    export let userId

    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let totalCount = 5
    let transactionType = 'all'
    let fromDate = 'firstDate'
    let toDate = 'lastDate'
    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    maxDate = yyyy+'-'+mm+'-'+dd

    function filter() {
        getAllTransactionWithFilter.send({
            data: {
                filterList: {
                    userId,
                    TypeTransaction: transactionType,
                    firstDate: fromDate,
                    lastDate: toDate,
                    page: currentPage + 1,
                    perPage
                }
            }
        })
        $getAllTransactionWithFilter.value
    }

    $:currentPage,perPage,filter()

    function reset() {
        fromDate = 'firstDate'
        toDate = 'lastDate'
        filter()
    }

    function isObject(obj) {
        return typeof obj === 'object'
    }
</script>

<div class="d-flex mb-3">
    <div class="pc-line">
        <span class="date-label">From</span>
        <input type="date" bind:value={fromDate} class="form-control w-auto" max="{maxDate}">
    </div>
    <div class="pc-line">
        <span class="date-label">To</span>
        <input type="date" bind:value="{toDate}" class="form-control w-auto" max="{maxDate}">
    </div>
    <div class="pc-line">
        <label>
            <input type="checkbox" checked={transactionType === 'debit'} on:click={() => {
                transactionType === 'all' ? transactionType = 'debit' : transactionType = 'all'
            }}> Debit only
        </label>
    </div>
    <div class="pc-line">
        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
        <button class="btn btn-secondary" on:click={reset}>Reset</button>
    </div>
</div>

{#if $getAllTransactionWithFilter.hasValue}
    <PerPage
        bind:perPage={perPage}
        disabled={$getAllTransactionWithFilter.loading || $getAllTransactionWithFilter.loading}
        totalCount={$getAllTransactionWithFilter.value.totalCount}
    />
{/if}

<div class="transactions-list">
    <div class="row">
        <div class="col-auto">
            <Table bordered striped responsive>
                <thead>
                    <tr>
                        <td class="text-center">Amount</td>
                        <td class="text-center">Description</td>
                        <td class="text-center">Date</td>
                    </tr>
                </thead>
                <tbody>
                {#if $getAllTransactionWithFilter.loading}
                    {#each {length:perPage} as item}
                        <tr>
                            <td><span class="loading transaction-loading"></span></td>
                            <td><span class="loading transaction-loading"></span></td>
                            <td><span class="loading transaction-loading"></span></td>
                        </tr>
                    {/each}
                {:else if $getAllTransactionWithFilter.error || !$getAllTransactionWithFilter.hasValue }
                    <tr>
                        <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                    </tr>
                {:else}
                    {#each $getAllTransactionWithFilter.value.data as { createdAt, credit, debit, currency, reason, txId }}
                        <tr>
                            <td class="nobr notranslate">
                                {#if debit > 0}
                                    <span class="text-success">+{debit} {currency}</span>
                                {:else if credit > 0}
                                    <span class="text-danger">-{credit} {currency}</span>
                                {:else}
                                    <span>0 {currency}</span>
                                {/if}
                            </td>
                            <td>
                                {#if isObject(reason)}
                                    {Object.values(JSON.parse(reason))[0]}
                                {:else if reason !== '{}'}
                                    {reason}
                                {/if}
                            </td>
                            <td class="text-center"><Time relative timestamp={createdAt}/></td>
                        </tr>
                    {:else}
                        <tr>
                            <td class="text-center" colspan="3">No items</td>
                        </tr>
                    {/each}
                {/if}
                </tbody>
            </Table>
            {#if $getAllTransactionWithFilter.hasValue}
                <Pagination
                    bind:currentPage={currentPage}
                    totalCount={$getAllTransactionWithFilter.value.totalCount}
                    {perPage}
                    {maxButtons}
                    disabled={$getAllTransactionWithFilter.loading || $getAllTransactionWithFilter.loading}
                />
            {/if}
        </div>
        <div class="col">
            {#if $getAllTransactionWithFilter.hasValue}
                {#each JSON.parse($getAllTransactionWithFilter.value.totalSum.trim() || '[]') as item}
                    {#each Object.entries(item) as [key, value]}
                        <div><strong>{key}</strong>: {roundNumberFloor(+value, 4)}</div>
                    {/each}
                {/each}
            {/if}
        </div>
    </div>
</div>

<style>
    .transactions-list :global(table) {
        width: auto;
    }

    .transactions-list :global(td) {
        vertical-align: middle;
        padding: 12px 25px;
        line-height: normal;
    }

    .transactions-list :global(nav .pagination) {
        justify-content: flex-start;
    }

    .pc-line {
        display: flex;
        align-items: center;
        margin-left: 15px;
    }

    .pc-line span {
        padding-right: 12px;
    }

    .btn-filter {
        margin-right: 6px;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }
</style>
